import { useCallback, useRef, useState } from "react";
import { ButtonPrivateHeader } from "views/components/controles/buttons";
import { LixoIcon, VoltarIcon } from "views/components/icons";
import { useHistory, useParams } from "react-router-dom";
import { PrivatePageHeader } from "views/components/headers";
import { Box, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper, Typography } from "@material-ui/core";
import { useDeleteRemoverPropaganda } from "data/api/gestao/propaganda/delete-remover-propaganda";
import { CircularLoading } from "views/components";
import { useToastSaurus } from "services/app";
import { useConfirm } from "material-ui-confirm";
import { useThemeQueries } from "views/theme";
import MoreVertIcon from '@material-ui/icons/MoreVert';

export type PropagandaEdicaoHeaderType = {
  podeExcluirPropaganda: boolean
}

export const PropagandaEdicaoHeader = ({ podeExcluirPropaganda }: PropagandaEdicaoHeaderType) => {
  const { push } = useHistory();
  const { propagandaId } = useParams<{ propagandaId: string }>();
  const { deleteRemoverPropaganda, carregando } = useDeleteRemoverPropaganda()
  const { showToast } = useToastSaurus()
  const confirm = useConfirm()
  const { isMobile } = useThemeQueries();

  const [openSWOptions, setOpenSWOptions] = useState<boolean>(false)
  const swOptionsRef = useRef<HTMLButtonElement>(null)

  const voltarTela = useCallback(
    () => {
      push(`/propaganda`)
    }, [push])

  const leftArea = useCallback(
    () => (
      <ButtonPrivateHeader
        icon={<VoltarIcon tipo="PRIVATE_HEADER" />}
        tooltip="Voltar"
        onClick={voltarTela}
      />
    ),
    [voltarTela])

  const handleToggleOptions = () => {
    setOpenSWOptions((prevOpen) => !prevOpen);
  };

  const handleRemoverPropaganda = useCallback(async () => {
    try {
      const res = await deleteRemoverPropaganda(propagandaId)
      if (res.erro) throw res.erro

      showToast('success', 'Propaganda removida com sucesso')
      push(`/propaganda`)
    } catch (error) {
      console.log(error)
    }
  }, [deleteRemoverPropaganda, propagandaId, push, showToast])

  const onClickRemoverPropaganda = useCallback(() => {
    confirm({
      title: 'Remover propaganda',
      description: 'Tem certeza que deseja remover a propaganda?',
      confirmationButtonProps: {
        variant: "contained",
        color: 'primary'
      },
      confirmationText: 'Remover',
      cancellationText: 'Cancelar'
    }).then(() => {
      handleRemoverPropaganda()
    })
  }, [confirm, handleRemoverPropaganda])

  const rightArea = useCallback(
    () => (
      <>
        <ButtonPrivateHeader
          icon={
            <MoreVertIcon
              style={{
                color: isMobile ? '#FFFFFF' : '#666',
              }}
            />}
          tooltip="Opções"
          ref={swOptionsRef}
          onClick={handleToggleOptions}
        />
        <Popper open={openSWOptions} anchorEl={swOptionsRef.current} placement="top" role={undefined} transition disablePortal style={{ zIndex: 999 }}>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleToggleOptions}>
                  <MenuList autoFocusItem={openSWOptions} id="menu-list-grow">
                    <MenuItem onClick={onClickRemoverPropaganda}>
                      <Box display='flex' alignItems='center'>
                        <LixoIcon tipo='BUTTON' />
                        <Typography color='primary'>Remover Propaganda</Typography>
                      </Box>
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>
    ),
    [isMobile, onClickRemoverPropaganda, openSWOptions])

  return (
    <>
      {carregando && <CircularLoading tipo="FULLSIZED" />}
      <PrivatePageHeader
        title="Editar propaganda"
        leftArea={leftArea()}
        rightArea={podeExcluirPropaganda ? rightArea() : null}
      />
    </>
  );
};
